import {Dayjs} from "dayjs";

export interface PunchesData {
    auditInfo:
        {
            createdOn: Date | string;
            createdBy: string;
            updatedOn: Date | string;
            updatedBy: string;
        };
    date: string;
    employeeId: string;
    id: string;
    name: {
        firstName: string,
        middleName: string,
        lastName: string
    };
    time: string;
    type: string;
}

export interface Attendance {
    id: string;
    employeeId: string;
    employeeName: {
        firstName: string;
        middleName: string;
        lastName: string;
    };
    date: string;
    status: string;
    profilePhotoThumbnailId?: string;
    checkInTime?: string;
    checkOutTime?: string;
    workingHours?: string;
}


export interface AttendanceCount {
    date: Dayjs | string;
    activeEmployee: number;
    present: number;
    absent: number;
    onLeave: number;
    attendanceRate: number;
}

export interface EmployeeAttendanceCount {
    holidays: number,
    presentDays: number,
    absentDays: number,
    leaveDays: number,
    weekends: number,
    month: string,
}

export enum AttendanceStatus {
    HOLIDAY = 'HOLIDAY',
    ON_LEAVE = 'ON LEAVE',
    PRESENT = 'PRESENT',
    ABSENT = 'ABSENT',
    WEEKEND = 'WEEKEND'
}


export interface AttendanceSummary {
    employeeId: string;
    employeeName: {
        firstName: string;
        middleName: string;
        lastName: string;
    },
    year: number;
    months: MonthSummary[];
}

export interface MonthSummary {
    month: string;
    workingDays: number;
    presentDays: number;
    leaveDays: number;
    absentDays: number;
    holidays: number;
    weekends: number;
    workingHours: string;
}

